<template>
  <v-card :elevation="elevation" color="secondary" class="lighten-5">
    <v-card-title class="text-center">{{ dateFormate }}</v-card-title>
    <v-divider class="mx-2" />
    <v-card-subtitle>Repas du midi</v-card-subtitle>
    <v-card-text>
      <v-chip color="secondary" class="mr-2 lighten-3">{{ previsionJour.nombreRepasMidi }} </v-chip>Personnes prévues
    </v-card-text>
    <v-divider class="mx-2" />
    <v-card-subtitle>Repas du Soir</v-card-subtitle>
    <v-card-text>
      <v-chip color="secondary" class="mr-2 lighten-3">{{ previsionJour.nombreRepasSoir }} </v-chip>Personnes prévues
    </v-card-text>
  </v-card>
</template>
<script>
import moment from 'moment'

export default {
  name: 'carte-prevision-restauration-jour',
  props: {
    previsionJour: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    elevation: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    dateFormate() {
      return moment(this.date).format('dddd DD MMM')
    },
  },
}
</script>
